// extracted by mini-css-extract-plugin
export var avatarContainer = "_a6-0";
export var avatarTypingWave = "_a6-i";
export var gray = "_a6-f";
export var green = "_a6-c";
export var icon = "_a6-9";
export var image = "_a6-1";
export var lg = "_a6-6";
export var md = "_a6-5";
export var presenceDot = "_a6-b";
export var red = "_a6-d";
export var sm = "_a6-4";
export var status = "_a6-a";
export var typingDot = "_a6-h";
export var typingPill = "_a6-g";
export var xl = "_a6-7";
export var xs = "_a6-3";
export var xxl = "_a6-8";
export var xxs = "_a6-2";
export var yellow = "_a6-e";